import React from 'react';
import DialogModal from '@/modules/common/components/Modal/DialogModal';
import { Button, Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import { Phone } from 'lucide-react';
import { useRouter } from 'next/router';
import useIsMobile from '@/hooks/useIsMobile';
import { COUNSELLER_PHONE_NUMBER } from '@/modules/common/constants';
type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const AdmissionClosedModal = ({
  isOpen,
  onClose
}: Props) => {
  const router = useRouter();
  const isMobileScreen = useIsMobile();
  const goToHomepage = () => {
    router.push('/');
  };
  const handleCall = () => {
    window.open(`tel:+91${COUNSELLER_PHONE_NUMBER}`, '_self');
  };
  return <DialogModal isOpen={isOpen} title="" onClose={onClose} onSubmit={() => null} showHeader={false} showSeparator={false} showFooter={false} showCancelButton={false} showSubmitButton={false} closeOnOutsideClick={false} showCloseIcon size="extra-small" data-sentry-element="DialogModal" data-sentry-component="AdmissionClosedModal" data-sentry-source-file="AdmissionClosedModal.tsx">
      <div className="relative flex flex-col items-center gap-2 mt-4 text-center">
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/0b228762-9033-49ed-99a2-3483d037662d.svg" alt="admission-closed-gif" width={100} height={100} data-sentry-element="Image" data-sentry-source-file="AdmissionClosedModal.tsx" />
        <Typography variant="heading3" weight="semi-bold" className="!text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="AdmissionClosedModal.tsx">
          Admissions Closed for This Course
        </Typography>
        <Typography variant="heading4" className="!text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="AdmissionClosedModal.tsx">
          Please choose another program to continue your application
        </Typography>
      </div>
      <div className="flex w-full gap-2 mt-4">
        <Button variant="lowFocus" onClick={goToHomepage} className="w-1/2 !border !border-[#196CDC] !text-[#196CDC]" data-sentry-element="Button" data-sentry-source-file="AdmissionClosedModal.tsx">
          Go to homepage
        </Button>

        {isMobileScreen ? <Button variant="primary" onClick={handleCall} className="w-1/2" preIcon={<>
                <Phone size={20} />
              </>}>
            Call Counsellor
          </Button> : <div className="flex items-center justify-center w-1/2 gap-1 py-2 font-semibold border text-white bg-[#196CDC] rounded-lg">
            <Phone />
            <Typography>Call +91-{COUNSELLER_PHONE_NUMBER}</Typography>
          </div>}
      </div>
    </DialogModal>;
};
export default AdmissionClosedModal;